<div class="bank-accounts">
  <div class="bank-accounts__header">
    <div class="bank-accounts__header-text">
      <h3 class="bank-accounts__title">{{ 'bankAccount' | translate }}</h3>
      <p class="bank-accounts__subtitle">{{ 'BankAccount.LIST_SUBTITLE' | translate }}</p>
    </div>
    <button type="button" class="bank-accounts__add-btn" (click)="addBankAccount()">
      <i class="fa-solid fa-plus"></i>
      <span>{{ 'BankAccount.ADD_NEW_BANK_ACCOUNT' | translate }}</span>
    </button>
  </div>

  <div *ngIf="loading" class="bank-accounts__state bank-accounts__state--loading">
    <i class="fa fa-spinner fa-spin"></i>
    <span>{{ 'loading' | translate }}</span>
  </div>

  <div
    *ngIf="!loading && (!bankAccounts || bankAccounts.length === 0)"
    class="bank-accounts__state bank-accounts__state--empty"
  >
    <div class="bank-accounts__empty-icon">
      <i class="fa-solid fa-building-columns"></i>
    </div>
    <p class="bank-accounts__empty-title">{{ 'BankAccount.NO_BANK_ACCOUNT' | translate }}</p>
    <p class="bank-accounts__empty-text">{{ 'noBankAccountsFound' | translate }}</p>
    <button type="button" class="bank-accounts__add-btn bank-accounts__add-btn--inline" (click)="addBankAccount()">
      <i class="fa-solid fa-plus"></i>
      <span>{{ 'BankAccount.ADD_NEW_BANK_ACCOUNT' | translate }}</span>
    </button>
  </div>

  <div *ngIf="!loading && bankAccounts?.length" class="bank-accounts__grid">
    <article
      *ngFor="let account of bankAccounts"
      class="bank-account-card"
      (click)="openAccountDetail(account)"
      role="button"
      tabindex="0"
      (keyup.enter)="openAccountDetail(account)"
    >
      <div class="bank-account-card__top">
        <div class="bank-account-card__icon" aria-hidden="true">
          <i class="fa-solid fa-building-columns"></i>
        </div>
        <div class="bank-account-card__badges">
          <span class="bank-account-card__badge bank-account-card__badge--primary" *ngIf="account.isPrimary">
            {{ 'BankAccount.PRIMARY' | translate }}
          </span>
          <span class="bank-account-card__badge">{{ 'BankAccount.TITLE_BANK_ACCOUNT' | translate }}</span>
        </div>
      </div>

      <div class="bank-account-card__body">
        <h4 class="bank-account-card__bank-name">{{ getAccountBankName(account) }}</h4>
        <p class="bank-account-card__beneficiary">
          <i class="fa-regular fa-user"></i>
          <span>{{ account.name }}</span>
        </p>
        <div class="bank-account-card__iban" dir="ltr">
          <i class="fa-solid fa-credit-card"></i>
          <span>{{ getListIbanDisplay(account.iban) }}</span>
        </div>
        <p class="bank-account-card__date" *ngIf="account.createdAt">
          <i class="fa-regular fa-calendar"></i>
          <span>{{ account.createdAt }}</span>
        </p>
      </div>

      <div class="bank-account-card__footer">
        <span>{{ 'BankAccount.VIEW_DETAILS' | translate }}</span>
        <i class="fa-solid fa-chevron-left bank-account-card__chevron bank-account-card__chevron--rtl" *ngIf="currentLang === 'ar'"></i>
        <i class="fa-solid fa-chevron-right bank-account-card__chevron" *ngIf="currentLang !== 'ar'"></i>
      </div>
    </article>
  </div>
</div>

<!-- Account details dialog -->
<p-dialog
  [(visible)]="detailDialogVisible"
  [modal]="true"
  appendTo="body"
  [closable]="!deleting"
  [draggable]="false"
  [resizable]="false"
  styleClass="bank-account-dialog bank-account-dialog--detail"
  [style]="{ width: 'min(94vw, 820px)' }"
  [header]="'BankAccount.ACCOUNT_DETAILS' | translate"
  (onHide)="closeDetailDialog()"
>
  <div *ngIf="detailLoading" class="text-center my-4">
    <i class="fa fa-spinner fa-spin"></i> {{ 'loading' | translate }}
  </div>

  <div *ngIf="!detailLoading && selectedAccount" class="bank-detail-dialog">
    <div class="bank-detail-dialog__row">
      <span class="bank-detail-dialog__label">{{ 'bankName' | translate }}</span>
      <span class="bank-detail-dialog__value">{{ bankName }}</span>
    </div>
    <div class="bank-detail-dialog__row">
      <span class="bank-detail-dialog__label">{{ 'BankAccount.BENEFICIARY_NAME' | translate }}</span>
      <span class="bank-detail-dialog__value">{{ selectedAccount.beneficiaryName }}</span>
    </div>
    <div class="bank-detail-dialog__row">
      <span class="bank-detail-dialog__label">{{ 'ibanNumber' | translate }}</span>
      <span class="bank-detail-dialog__value bank-detail-dialog__value--iban">
        <span dir="ltr">{{ displayedIban }}</span>
        <button
          type="button"
          class="iban-toggle-btn"
          (click)="toggleIbanVisibility(); $event.stopPropagation()"
          [attr.aria-label]="showIban ? ('BankAccount.HIDE_IBAN' | translate) : ('BankAccount.SHOW_IBAN' | translate)"
        >
          <i class="fa-regular" [ngClass]="showIban ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </span>
    </div>
    <div class="bank-detail-dialog__row">
      <span class="bank-detail-dialog__label">{{ 'BankAccount.ADDED_DATE' | translate }}</span>
      <span class="bank-detail-dialog__value">{{ selectedAccount.createdAt }}</span>
    </div>
    <div class="bank-detail-dialog__row bank-detail-dialog__row--primary">
      <span class="bank-detail-dialog__label">{{ 'BankAccount.PRIMARY_TOGGLE' | translate }}</span>
      <span class="bank-detail-dialog__value bank-detail-dialog__value--toggle">
        <mat-slide-toggle
          color="primary"
          [checked]="!!selectedAccount.isPrimary"
          [disabled]="!!selectedAccount.isPrimary || settingPrimary"
          (change)="onPrimaryToggle($event.checked)"
        ></mat-slide-toggle>
        <span class="primary-status" *ngIf="selectedAccount.isPrimary">
          {{ 'BankAccount.PRIMARY' | translate }}
        </span>
      </span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="bank-detail-dialog__footer" *ngIf="!detailLoading && selectedAccount">
      <button
        type="button"
        class="bank-dialog-btn bank-dialog-btn--secondary"
        (click)="closeDetailDialog()"
        [disabled]="deleting || settingPrimary"
      >
        {{ 'Shared.CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="bank-dialog-btn bank-dialog-btn--primary"
        *ngIf="!selectedAccount.isPrimary"
        (click)="setAsPrimary()"
        [disabled]="deleting || settingPrimary"
      >
        <i class="fa fa-spinner fa-spin" *ngIf="settingPrimary"></i>
        <i class="fa-solid fa-star" *ngIf="!settingPrimary"></i>
        {{ 'BankAccount.SET_AS_PRIMARY' | translate }}
      </button>
      <button
        type="button"
        class="bank-dialog-btn bank-dialog-btn--danger"
        (click)="startDelete()"
        [disabled]="deleting || settingPrimary"
      >
        <i class="fa-solid fa-trash-can" *ngIf="!deleting"></i>
        <i class="fa fa-spinner fa-spin" *ngIf="deleting"></i>
        {{ 'BankAccount.DELETE_ACCOUNT' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- OTP dialog -->
<p-dialog
  [(visible)]="otpDialogVisible"
  [modal]="true"
  appendTo="body"
  [closable]="!deleting"
  [draggable]="false"
  [resizable]="false"
  styleClass="bank-account-dialog bank-account-dialog--otp"
  [style]="{ width: 'min(94vw, 640px)' }"
  [header]="'BankAccount.DELETE_OTP_TITLE' | translate"
  (onHide)="closeOtpDialog()"
>
  <div class="otp-dialog-body">
    <p class="otp-intro">{{ 'BankAccount.DELETE_OTP_INTRO' | translate }}</p>
    <app-otp-input
      *ngIf="otpDialogVisible"
      [phoneNumber]="userPhone"
      [generateNewOtp]="true"
      [operationType]="deleteBankAccountOtpOperationType"
      (onValidationSuccess)="onOtpVerified($event)"
    ></app-otp-input>
  </div>

  <ng-template pTemplate="footer">
    <div class="delete-otp-dialog__footer">
      <button
        pButton
        type="button"
        class="p-button-text bank-dialog-btn--secondary"
        [label]="'CANCEL' | translate"
        (click)="closeOtpDialog()"
        [disabled]="deleting"
      ></button>
    </div>
  </ng-template>
</p-dialog>
